<ng-container>
  @for (wage of currentValue; track wage; let i = $index) {
    <tr class="key-value-row">
      <td class="key-value-row__key">{{ ('Wage' | translate) + ' ' + addWageCount(i) }}</td>
      <td class="key-value-row__value">{{ wage }}</td>
    </tr>
  }

  @if (hasHistory) {
    <tr>
      <td colspan="2">
        <mat-expansion-panel #panel>
          <mat-expansion-panel-header>
            <mat-panel-title>{{ 'Annex.WagesHistory' | translate }}</mat-panel-title>
          </mat-expansion-panel-header>

          @for (entry of history; track entry.annexId ?? 'original') {
            @if (entry.isOriginal) {
              <div>
                {{ 'Annex.OriginalFromDate' | translate }}
                {{ entry.conclusionDate | date: 'dd.MM.yyyy' }} -
                {{ 'Annex.AgreementEffectiveFrom' | translate }}
                {{ entry.startDate | date: 'dd.MM.yyyy' }} -
                {{ formatWages(entry) }}
              </div>
            } @else {
              <div (click)="onAnnexClick($event, entry)" style="cursor: pointer; text-decoration: underline">
                {{ 'Annex.AnnexFromDate' | translate }}
                {{ entry.conclusionDate | date: 'dd.MM.yyyy' }} -
                {{ 'Annex.EffectiveFrom' | translate }}
                {{ entry.startDate | date: 'dd.MM.yyyy' }} -
                {{ formatWages(entry) }}
                @if (entry.isCurrent) {
                  <strong>({{ 'Annex.Current' | translate }})</strong>
                }
              </div>
            }
          }
        </mat-expansion-panel>
      </td>
    </tr>
  }
</ng-container>
